import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitotelanganacabservice() {



    const cardData = {





keyword: "Mumbai to Telangana Cab Service",

headingDescription: "Shreesha Tours & Travels offers comfortable and reliable Mumbai to Telangana Cab Service for family travel, business trips, corporate transportation, pilgrimage tours, airport transfers, one-way cab booking, round trips, and long-distance journeys. We provide chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, and premium cab options for a safe and convenient travel experience from Mumbai to different cities and destinations in Telangana. Our experienced drivers, well-maintained vehicles, transparent pricing, flexible travel plans, doorstep pickup, and 24/7 customer support ensure a smooth and hassle-free journey. Whether you are traveling for tourism, business meetings, religious visits, medical purposes, or family occasions, Shreesha Tours & Travels provides dependable cab services with complete comfort and convenience.",

topPlaces: [
  {
    title: "Hyderabad",
    description: "Hyderabad is the capital city of Telangana, famous for Charminar, Golconda Fort, Ramoji Film City, Hussain Sagar Lake, Salar Jung Museum, and its rich cultural heritage. It is one of the most popular destinations from Mumbai."
  },
  {
    title: "Warangal",
    description: "Warangal is a historic city known for Warangal Fort, Thousand Pillar Temple, Ramappa Temple, and ancient Kakatiya architecture. It is an excellent destination for heritage and cultural tours."
  },
  {
    title: "Yadadri Bhuvanagiri",
    description: "Yadadri is a famous pilgrimage destination known for the Yadadri Lakshmi Narasimha Temple. Devotees from across India visit this beautifully developed temple complex."
  },
  {
    title: "Nizamabad",
    description: "Nizamabad is known for Nizamabad Fort, Dichpally Ramalayam Temple, Alisagar Reservoir, and scenic surroundings. It is a popular destination for family trips and cultural exploration."
  },
  {
    title: "Karimnagar",
    description: "Karimnagar is an important Telangana city known for Elgandal Fort, Lower Manair Dam, temples, and historical attractions. It is suitable for business and leisure travel."
  },
  {
    title: "Khammam",
    description: "Khammam is famous for Khammam Fort, temples, historical sites, and nearby natural attractions. It is a preferred destination for travelers exploring Telangana."
  },
  {
    title: "Basara",
    description: "Basara is a major pilgrimage destination famous for Gnana Saraswati Temple, attracting families and devotees throughout the year."
  },
  {
    title: "Vemulawada",
    description: "Vemulawada is known for the famous Rajanna Temple dedicated to Lord Shiva. It is one of Telangana's important religious destinations."
  },
  {
    title: "Medak",
    description: "Medak is famous for Medak Cathedral, Medak Fort, and beautiful landscapes. It is a popular destination for history lovers and weekend travelers."
  },
  {
    title: "Srisailam",
    description: "Srisailam is a major pilgrimage destination near Telangana, famous for Mallikarjuna Jyotirlinga Temple, Srisailam Dam, and forest landscapes. It is ideal for religious and family tours."
  }
],




"services": [
  {
    "name": "Mumbai to Telangana Cab",
    "description": "Book Mumbai to Telangana Cab for safe, comfortable, and reliable interstate travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova, Innova Crysta, SUV, and premium cars for family trips, business journeys, airport transfers, and long-distance travel across Telangana with flexible one way and round trip options."
  },
  {
    "name": "Mumbai to Telangana Taxi",
    "description": "Choose Mumbai to Telangana Taxi for convenient and affordable long-distance transportation with experienced drivers and comfortable vehicles. Enjoy doorstep pickup, clean AC cars, transparent pricing, and reliable taxi service for personal, corporate, and family travel needs."
  },
  {
    "name": "Mumbai to Telangana Cab Service",
    "description": "Book Mumbai to Telangana Cab Service for dependable interstate travel with trained chauffeurs and premium vehicles. Our cab services provide comfortable solutions for business trips, family vacations, medical travel, religious journeys, and private transportation requirements."
  },
  {
    "name": "Mumbai to Telangana Taxi Service",
    "description": "Hire Mumbai to Telangana Taxi Service for smooth highway journeys with professional drivers and well-maintained cars. Get reliable transportation with flexible booking options, comfortable seating, and affordable cab packages from Mumbai to Telangana."
  },
  {
    "name": "Mumbai to Telangana Cab Booking",
    "description": "Complete Mumbai to Telangana Cab Booking with easy online reservations, quick confirmation, and multiple vehicle options. Select Sedan, SUV, Ertiga, Innova, or premium cars according to your group size and travel requirements for a comfortable journey."
  },
  {
    "name": "Mumbai to Telangana Car Rental",
    "description": "Choose Mumbai to Telangana Car Rental for chauffeur-driven vehicles designed for long-distance interstate travel. Enjoy spacious cars, experienced drivers, flexible schedules, and affordable rental plans for family tours, corporate travel, and personal journeys."
  },
  {
    "name": "Mumbai to Telangana Outstation Cab",
    "description": "Book Mumbai to Telangana Outstation Cab for safe and reliable long-distance transportation with premium vehicles and professional chauffeurs. Perfect for interstate travel, family trips, business visits, and private journeys with comfortable highway travel."
  },
  {
    "name": "Mumbai to Telangana One Way Taxi",
    "description": "Reserve Mumbai to Telangana One Way Taxi for convenient drop taxi service without return fare charges. Travel comfortably with skilled drivers, clean vehicles, and flexible pickup locations for a hassle-free one-way journey."
  },
  {
    "name": "Mumbai to Telangana Round Trip Cab",
    "description": "Choose Mumbai to Telangana Round Trip Cab for complete return travel solutions with flexible timings and comfortable vehicles. Ideal for family visits, corporate trips, sightseeing tours, and extended stays across Telangana."
  },
  {
    "name": "Mumbai Airport to Telangana Cab",
    "description": "Book Mumbai Airport to Telangana Cab for smooth airport transfer and interstate travel services. Enjoy timely pickup, luggage-friendly vehicles, professional drivers, and comfortable transportation from Mumbai Airport to Telangana destinations."
  },
  {
    "name": "Mumbai to Hyderabad Telangana Cab",
    "description": "Book Mumbai to Hyderabad Telangana Cab for reliable travel between Mumbai and Hyderabad with experienced chauffeurs and premium vehicles. Enjoy comfortable rides for business trips, family travel, airport transfers, and long-distance journeys."
  },
  {
    "name": "Mumbai to Telangana Private Taxi",
    "description": "Hire Mumbai to Telangana Private Taxi for personalized travel with a dedicated vehicle and professional chauffeur. Enjoy privacy, flexible routes, comfortable seating, and a peaceful journey for business or personal transportation."
  },
  {
    "name": "Mumbai to Telangana Innova Cab",
    "description": "Choose Mumbai to Telangana Innova Cab for spacious and comfortable travel with premium seating and extra luggage space. Ideal for families and groups planning a long-distance journey with complete comfort and convenience."
  },
  {
    "name": "Mumbai to Telangana Innova Crysta Cab",
    "description": "Book Mumbai to Telangana Innova Crysta Cab for luxury interstate travel with premium interiors, smooth performance, and experienced chauffeurs. Perfect for family tours, corporate travel, and passengers looking for a comfortable long-distance cab experience."
  },
  {
    "name": "Mumbai to Telangana Ertiga Cab",
    "description": "Reserve Mumbai to Telangana Ertiga Cab for affordable group travel with spacious seating and comfortable interiors. Suitable for families, small groups, and travelers searching for economical and reliable interstate cab services."
  },
  {
    "name": "Best Mumbai Telangana Cab Service",
    "description": "Choose the Best Mumbai Telangana Cab Service for safe, comfortable, and affordable interstate travel. Enjoy premium vehicles, trained chauffeurs, flexible booking options, and reliable service for family trips, corporate journeys, airport transfers, and long-distance travel from Mumbai to Telangana."
  }
],
"tableData": [
  ["Mumbai to Telangana Cab", "Mumbai to Telangana Taxi"],
  ["Mumbai to Telangana Cab Service", "Mumbai to Telangana Taxi Service"],
  ["Mumbai to Telangana Cab Booking", "Mumbai to Telangana Car Rental"],
  ["Mumbai to Telangana Outstation Cab", "Mumbai to Telangana One Way Taxi"],
  ["Mumbai to Telangana Round Trip Cab", "Mumbai Airport to Telangana Cab"],
  ["Mumbai to Hyderabad Telangana Cab", "Mumbai to Telangana Private Taxi"],
  ["Mumbai to Telangana Innova Cab", "Mumbai to Telangana Innova Crysta Cab"],
  ["Mumbai to Telangana Ertiga Cab", "Best Mumbai Telangana Cab Service"]
],




whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai to Telangana Cab Service",
    WhyChoosedescription: "Shreesha Travels provides comfortable Mumbai to Telangana cab services for family trips, business travel, relocation, medical visits, and personal journeys. Experience a smooth interstate ride with professional chauffeurs and well-maintained vehicles."
  },
  {
    WhyChooseheading: "Convenient Travel to Telangana Cities",
    WhyChoosedescription: "Travel from Mumbai to Hyderabad, Warangal, Karimnagar, Nizamabad, Khammam, and other Telangana destinations with flexible cab options designed according to your travel requirements."
  },
  {
    WhyChooseheading: "Wide Range of Vehicles Available",
    WhyChoosedescription: "Choose from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and other vehicles based on passenger strength and luggage needs."
  },
  {
    WhyChooseheading: "Perfect for Family, Corporate & Personal Travel",
    WhyChoosedescription: "Our Mumbai to Telangana cabs are suitable for family visits, corporate tours, airport transfers, business meetings, educational trips, medical travel, and customized road journeys."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Options",
    WhyChoosedescription: "Book a one-way taxi for direct travel to Telangana or select a round-trip package with flexible return schedules and personalized travel arrangements."
  },
  {
    WhyChooseheading: "Experienced Drivers for Interstate Routes",
    WhyChoosedescription: "Our skilled chauffeurs have experience with long-distance highway travel and ensure safe driving, timely pickups, and comfortable journeys throughout the Mumbai to Telangana route."
  },
  {
    WhyChooseheading: "Comfortable Cars Ready for Long Journeys",
    WhyChoosedescription: "Every vehicle is regularly serviced, cleaned, air-conditioned, and inspected before departure to provide passengers with a reliable and relaxing travel experience."
  },
  {
    WhyChooseheading: "Book Mumbai to Telangana Cab with Shreesha Travels",
    WhyChoosedescription: "Enjoy transparent pricing, quick booking support, flexible travel plans, and dependable chauffeur-driven transportation for your journey from Mumbai to Telangana."
  }
]

};

const faqData = [
  {
    question: "Can I book a Mumbai to Telangana cab for any city?",
    answer: "Yes, we provide cab services from Mumbai to major Telangana destinations including Hyderabad, Warangal, Karimnagar, Nizamabad, Khammam, and other locations."
  },
  {
    question: "Is Mumbai to Telangana one-way cab service available?",
    answer: "Yes, one-way cab booking is available for passengers who require direct travel from Mumbai to Telangana."
  },
  {
    question: "Which vehicles are suitable for Mumbai to Telangana travel?",
    answer: "Sedans are suitable for small groups, while Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, and Tempo Travellers are ideal for families and larger groups."
  },
  {
    question: "Can I book a round-trip taxi from Mumbai to Telangana?",
    answer: "Yes, round-trip cab packages are available with flexible return dates and customized travel plans."
  },
  {
    question: "Are Mumbai to Telangana cabs available for corporate travel?",
    answer: "Yes, our cab services are suitable for business meetings, employee transportation, official tours, and corporate requirements."
  },
  {
    question: "Can I customize my Mumbai to Telangana travel route?",
    answer: "Yes, you can customize the route with planned stops, sightseeing locations, and additional destinations according to your itinerary."
  },
  {
    question: "Do you provide airport pickup and drop services in Telangana?",
    answer: "Yes, airport transfer services can be arranged for Telangana airports and major city locations as per your requirement."
  },
  {
    question: "How is the Mumbai to Telangana cab fare calculated?",
    answer: "The fare depends on the vehicle category, travel distance, trip duration, route, number of days, and additional requirements."
  },
  {
    question: "Are long-distance overnight journeys available?",
    answer: "Yes, overnight travel options are available with experienced drivers for comfortable interstate journeys."
  },
  {
    question: "How can I book Mumbai to Telangana Cab Service with Shreesha Travels?",
    answer: "Share your pickup location, destination city, travel date, passenger details, and preferred vehicle to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Patil",
    feedback: "The Mumbai to Telangana cab service was excellent. The vehicle was comfortable, the driver was professional, and the complete interstate journey was managed smoothly.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Reddy",
    feedback: "Our family trip from Mumbai to Telangana was very comfortable. The clean car, safe driving, and timely support made the long journey stress-free.",
    rating: 5
  }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Telangana Cab Service",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-telangana-cab-service.webp",
  "description":
    "Book Mumbai to Telangana Cab Service with Shreesha Tours & Travels for safe, comfortable, and affordable interstate taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for one-way trips, round trips, family travel, business journeys, airport transfers, and long-distance outstation travel from Mumbai to different cities across Telangana.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-telangana-cab-service"
  }
};



    return (
        <div>


<Helmet>
  <title>Mumbai to Telangana Cab Service | Outstation Taxi | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Telangana Cab Service with Shreesha Travels for reliable interstate taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for one-way and round-trip journeys, family trips, business travel, and outstation routes with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Mumbai to Telangana Cab, Mumbai to Telangana Taxi, Mumbai to Telangana Cab Service, Mumbai to Telangana Taxi Service, Mumbai to Telangana Cab Booking, Mumbai to Telangana Car Rental, Mumbai Telangana Outstation Cab, Mumbai Telangana One Way Taxi, Mumbai Telangana Round Trip Cab, Mumbai Airport to Telangana Taxi, Mumbai Long Distance Cab Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/67.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitotelanganacabservice;